import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic } from '../../theme/tokens';

export const StyledInput = styled.input<{ $variant: 'borderless' | 'outlined'; $error?: boolean }>`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
  padding: ${layout.inputPadding};
  border: ${(p) =>
    p.$variant === 'outlined'
      ? `1px solid ${p.$error ? semantic.border.danger : semantic.border.default}`
      : 'none'};
  border-radius: ${(p) => (p.$variant === 'outlined' ? layout.borderRadiusMd : '0')};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  background: transparent;

  &::placeholder {
    color: ${semantic.text.tertiary};
  }

  &:focus {
    background: ${(p) => (p.$variant === 'borderless' ? semantic.bg.surfaceSubtle : 'transparent')};
    border-color: ${(p) => (p.$variant === 'outlined' ? colors.primary : 'transparent')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[aria-invalid='true'] {
    border-color: ${(p) => (p.$variant === 'outlined' ? semantic.border.danger : 'transparent')};
  }
`;
